/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import _ from "lodash";
import React from "react";
import CheckBox from "../../../../../shared-ui/checkbox";
// import "react-accessible-accordion/dist/fancy-example.css";

interface MultipleChoiceComponentProps {
  questionType: string;
  questionValue: string;
  questionTitle: string;
  optionList: any;
  optionsListWithAnswer: any;
  dependent: any;
  disableAllAnswers: boolean;
  handleInputChange?: (
    questionType: string,
    questionValue: string,
    questionTitle: string,
    answer: any,
    isNeedState: boolean,
    isDependent: boolean,
    dependentQuestions: any
  ) => void;
}

interface MultipleChoiceComponentState {
  listOfOptions: any;
  questionTitleState: string;
}
class MultipleChoiceComponent extends React.Component<
  MultipleChoiceComponentProps,
  MultipleChoiceComponentState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      listOfOptions: [],
      questionTitleState: "",
    };
  }

  componentDidMount = () => {
    const { questionType, questionValue, questionTitle, disableAllAnswers } =
      this.props;
    if (
      questionType === "multiple_choice_short_answer" ||
      questionType === "multiple-selection"
    ) {
      if (this.props.optionsListWithAnswer !== undefined) {
        this.setState({
          listOfOptions: this.props.optionsListWithAnswer,
          // },()=>{
          //   if (this.props.handleInputChange) {
          //     this.props.handleInputChange(
          //       questionType,
          //       questionValue,
          //       questionTitle,
          //       this.props.optionsListWithAnswer
          //     );
          //   }
        });
      } else {
        let data = this.props.optionList;
        data.forEach(function (item: { isChecked: boolean }) {
          item.isChecked = false;
        });
        this.setState({
          listOfOptions: data,
        });
      }
    }
    if (
      questionType === "multiple_choice_short_answer_none" ||
      questionType === "multiple-selection-with-none"
    ) {
      if (this.props.optionsListWithAnswer !== undefined) {
        this.setState({
          listOfOptions: this.props.optionsListWithAnswer,
          // },()=>{
          //   if (this.props.handleInputChange) {
          //     this.props.handleInputChange(
          //       questionType,
          //       questionValue,
          //       questionTitle,
          //       this.props.optionsListWithAnswer
          //     );
          //   }
        });
      } else {
        let data = this.props.optionList;
        data.forEach(function (item: {
          isChecked: boolean;
          isDisabled: boolean;
        }) {
          item.isChecked = false;
          item.isDisabled = false;
        });
        this.setState({
          listOfOptions: data,
        });
      }
    }
  };

  componentDidUpdate = () => {
    if (this.state.questionTitleState !== this.props.questionTitle || (this.props.optionsListWithAnswer !== undefined && this.state.listOfOptions !==this.props.optionsListWithAnswer)) {
      this.setState({ questionTitleState: this.props.questionTitle });
      const { questionType, questionValue, questionTitle } = this.props;
      if (
        questionType === "multiple_choice_short_answer" ||
        questionType === "multiple-selection"
      ) {
        if (this.props.optionsListWithAnswer !== undefined && this.state.listOfOptions !==this.props.optionsListWithAnswer) {
          this.setState({
            listOfOptions: this.props.optionsListWithAnswer,
            // },()=>{
            //   if (this.props.handleInputChange) {
            //     this.props.handleInputChange(
            //       questionType,
            //       questionValue,
            //       questionTitle,
            //       this.props.optionsListWithAnswer
            //     );
            //   }
          });
        } else {
          let data = this.props.optionList;
          data.forEach(function (item: { isChecked: boolean }) {
            item.isChecked = false;
          });
          this.setState({
            listOfOptions: data,
          });
        }
      }
      if (
        questionType === "multiple_choice_short_answer_none" ||
        questionType === "multiple-selection-with-none"
      ) {
        if (this.props.optionsListWithAnswer !== undefined && this.state.listOfOptions !==this.props.optionsListWithAnswer) {
          this.setState({
            listOfOptions: this.props.optionsListWithAnswer,
            // },()=>{
            //   if (this.props.handleInputChange) {
            //     this.props.handleInputChange(
            //       questionType,
            //       questionValue,
            //       questionTitle,
            //       this.props.optionsListWithAnswer
            //     );
            //   }
          });
        } else {
          let data = this.props.optionList;
          data.forEach(function (item: {
            isChecked: boolean;
            isDisabled: boolean;
          }) {
            item.isChecked = false;
            item.isDisabled = false;
          });
          this.setState({
            listOfOptions: data,
          });
        }
      }
    }
  };
  getSelectedData = () => {
    let recoValues: Array<String> = [];
    if (!_.isEmpty(this.state.listOfOptions)) {
      _.map(this.state.listOfOptions, (data: any, index: any) => {
        if (data?.isChecked) {
          recoValues.push(data.id);
        }
      });
    }
    return recoValues;
  };

  handleCheckbox = (value: string, index: number) => {
    const { listOfOptions } = this.state;
    const { questionValue, questionTitle, questionType, dependent } =
      this.props;
    if (
      questionType === "multiple_choice_short_answer" ||
      questionType === "multiple-selection"
    ) {
      const data: any = listOfOptions;
      data[index].isChecked = !data[index].isChecked;
      this.setState({ listOfOptions: data }, () => {
        const selectedValues: any = this.getSelectedData();
        let valuesFound = false;
        let dependentQuestions: any = [];
        if (dependent && dependent.length > 0) {
          const conditionsArray = dependent[0]?.conditions;
          let newArray = _.intersection(conditionsArray, selectedValues);
          valuesFound = newArray.length > 0 ? true : false;
          dependentQuestions = dependent[0]?.questions;
        }
        if (this.props.handleInputChange) {
          this.props.handleInputChange(
            questionType,
            questionValue,
            questionTitle,
            listOfOptions,
            false,
            valuesFound,
            dependentQuestions
          );
        }
      });
    }

    if (
      questionType === "multiple_choice_short_answer_none" ||
      questionType === "multiple-selection-with-none"
    ) {
      const { listOfOptions } = this.state;
      const data: any = listOfOptions;

      data[index].isChecked = !data[index].isChecked;
      /*This code is used to handle disabling of options*/
      const uncheckedFilteredOptions = listOfOptions.filter(
        (obj: any) => obj.isChecked === false
      ).length;
      const allExceptNoneOptions = _.initial(data);
      const checkedFilteredOptions = allExceptNoneOptions.filter(
        (obj: any) => obj.isChecked === true
      ).length;
      if (
        index === listOfOptions.length - 1 &&
        data[listOfOptions.length - 1].isChecked === true
      ) {
        for (let i = 0; i < data.length - 1; i = i + 1) {
          data[i].isDisabled = true;
        }
      }
      if (checkedFilteredOptions > 0) {
        data[listOfOptions.length - 1].isDisabled = true;
      }
      if (uncheckedFilteredOptions === listOfOptions.length) {
        data.forEach((element: any) => {
          element.isDisabled = false;
        });
      }

      const selectedValues: any = this.getSelectedData();
      let valuesFound = false;
      let dependentQuestions: any = [];
      if (dependent && dependent.length > 0) {
        const conditionsArray = dependent[0]?.conditions;
        let newArray = _.intersection(conditionsArray, selectedValues);
        valuesFound = newArray.length > 0 ? true : false;
        dependentQuestions = dependent[0]?.questions;
      }
      this.setState({ listOfOptions: data }, () => {
        if (this.props.handleInputChange) {
          this.props.handleInputChange(
            questionType,
            questionValue,
            questionTitle,
            listOfOptions,
            false,
            valuesFound,
            dependentQuestions
          );
        }
      });
    }
  };

  render() {
    const { listOfOptions } = this.state;
    const { disableAllAnswers } = this.props;
    return (
      <div
        className={
          disableAllAnswers
            ? "answers-wrapper multiple-select-wrapper disabled "
            : "answers-wrapper multiple-select-wrapper"
        }
      >
        <div className="options-area">
          {listOfOptions &&
            listOfOptions.length > 0 &&
            listOfOptions.map((item: any, index: number) => (
              <div
                className={
                  item && item.isDisabled ? "option disable" : "option"
                }

              >
                {/* <div className="radio-btn"> */}
                <CheckBox
                  className={
                    "checkbox"
                    // isError ? "checkbox checkbox-error" : "checkbox"
                  }
                  onCheckboxClick={() => {
                    this.handleCheckbox(item.value, index);
                  }}
                  isChecked={item && item.isChecked}
                />
                {/* </div> */}
                <div className="option-label" onClick={() => {
                  this.handleCheckbox(item.value, index);
                }}>{item && item.value}</div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}

export default MultipleChoiceComponent;
